// src/pages/Contact.jsx
import React, { useEffect } from 'react';
import Layout from '../components/layout/Layout';
import ContactForm from '../components/contact/ContactForm';
import ContactInfo from '../components/contact/ContactInfo';
import Section from '../components/ui/Section';
import Heading from '../components/ui/Heading';

const Contact = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  return (
    <Layout>
      <Section className=" pb-0 pt-10 sm:py-10 sm:px-5 lg:px-10">
        <div className="mx-auto">
          <Heading level="2">Contact Us</Heading>
          <p className="text-xl text-gray-600 mt-4 max-w-3xl">
            Have a project in mind? Want to learn more about our sustainable design approaches? We'd love to hear from you.
          </p>
        </div>
      </Section>
      
      <Section className="bg-white py-16 sm:px-5 lg:px-10">
        <div className=" mx-auto ">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </Section>
      
      <Section className=" py-8 sm:py-12 sm:px-5 lg:px-10">
        <div className=" mx-auto ">
          <Heading level="3">Visit Our Office</Heading>
          <div className="mt-8 bg-gray-200 rounded-lg h-96 w-full">
        {/* Map Container */}
        <div className="w-full h-full rounded-lg overflow-hidden">
            <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3184.7707778846807!2d77.62021517774733!3d12.936005877691622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae144ff7dfb1f5%3A0x8245c34e452c8581!2s17th%20E%20Main%20Rd%2C%20Koramangala%2C%20Bengaluru%2C%20Karnataka%20560095!5e1!3m2!1sen!2sin!4v1743143852153!5m2!1sen!2sin"
            className="w-full h-full border-0 rounded-lg"
            title="Vasudharini Homes Office Location"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            ></iframe>

        </div>
        </div>
        </div>
      </Section>
    </Layout>
  );
};

export default Contact;